import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import Typography from 'Components/UI/Typography';
import { Tooltip } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import { fullDateTimeWithTz } from 'Consts/DateFormats';
import { formatDateLocal } from 'Consts/DateFormatWithMomentTimezone';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import LogDifferencesWrapper from './LogDifferences';

const styles = (theme) => ({
  root: {
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  accordion: {
    borderRadius: theme.radius.md,
    backgroundColor: theme.palette.facet.lightGray5,
    boxShadow: 'none',
  },
  summary: {
    display: 'flex',
    flexDirection: 'column',
  },
  details: {
    borderTop: `${theme.palette.facet.accentGray} 1px solid`,
    paddingTop: theme.spacing(2),
  },
});

function logMessage(expanded) {
  let message = 'Event log collapsed';
  if (expanded) {
    message = 'Event log expanded';
  }
  return message;
}

const Layout = ({
  className,
  classes,
  effectCollection,
}) => {
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { resource } = useMetaLayoutContext();
  const timezoneLongDate = formatDateLocal(resource.attr('eventTime'), fullDateTimeWithTz);

  function onAccordionChange(event, expanded) {
    logStandardizedEvent(categories.whatIf, eventTypes.clickButton, logMessage(expanded));
  }

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Accordion
        square
        className={classes.accordion}
        test={'facet-plan-log-accordion'}
        onChange={onAccordionChange}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
        >
          <div className={classes.summary}>
            <Typography
              color={'primary'}
              variant={'h5'}
            >
              {resource.attr('eventName')}
            </Typography>
            <Tooltip title={`By ${resource.attr('personName')}`}>
              <Typography
                variant={'subtitle2'}
              >
                {timezoneLongDate}
              </Typography>
            </Tooltip>
          </div>
        </AccordionSummary>
        {effectCollection && effectCollection.resources().list().length > 0 && (
          <AccordionDetails className={classes.details}>
            <ul>
              {effectCollection.resources().list().map((effectResource) => (
                <li
                  key={effectResource.id()}
                >
                  <Typography
                    variant={'subtitle2'}
                  >
                    {effectResource.attr('eventName')}
                  </Typography>
                  <LogDifferencesWrapper resource={effectResource} />
                </li>
              ))}
            </ul>
          </AccordionDetails>
        )}
      </Accordion>
    </Box>
  );
};

Layout.defaultProps = {
  className: '',
};

Layout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  effectCollection: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
